<template>
  <div class="header">
    <!-- <img src="@/assets/header.png" /> -->
    <div class="header_title">
      <div class="header_left">
        监管电站<span>{{ busPowerStationCount }}个</span>
      </div>
      <div class="header_left">
        全天供电量<span>{{ dataList.dayPowerSupply }}万度</span>
      </div>
      <div class="header_left">
        全天发电量<span>{{ dataList.daySum }}</span
        >万度
      </div>
      <div class="header_right_title">
        <div class="header_right">
          <div class="number">
            月累计<span>{{ dataList.mothSum }}</span
            >万度
          </div>
        </div>
        <div class="header_right">
          <div class="number">
            年产量<span>{{ dataList.yarSum }}</span
            >万度
          </div>
        </div>
        <div class="header_right">
          <div class="number">
            年完成<span>{{ dataList.yearCompletionRate }}%</span>
          </div>
        </div>
        <div class="header_right">
          <div class="context">
            <div class="progressBarTop">
              <div
                class="progressBar"
                :style="{ width: yearCompletionRate + '%' }"
              ></div>
            </div>
          </div>
        </div>
        <!-- <div class="edit" v-if="edit" @click="editTo">
          <i class="el-icon-edit"></i>
        </div> -->
        <div class="header_tisk">
          <el-badge :value="badge" class="item">
            <img src="@/assets/warning.png" @click="changeActive()" />
          </el-badge>
        </div>
        <div class="toolTipBox" v-if="toolTipBox">
          <div class="title">
            <div>预警记录</div>
            <i class="el-icon-close close" @click="close"></i>
          </div>
          <el-table
            :data="stationInformation"
            border
            size="mini"
            max-height="350"
            style="width: 100%"
          >
            <el-table-column prop="realName" align="center" label="名称" center>
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.templateParam.organName +
                    scope.row.templateParam.sceneLinkName
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="dataTime" align="center" label="预警时间" center>
            </el-table-column>
            <el-table-column
              header-align="center"
              fixed="right"
              align="center"
              label="操作"
              center
            >
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var formatNum = function (num) {
  return num < 10 ? "0" + num : num;
};
import axios from "axios";
export default {
  data() {
    return {
      toolTipBox: false,
      dataList: {},
      yearCompletionRate: "",
      busPowerStationCount: "",
      stationInformation: [],
      badge: 0,
    };
  },
  filters: {
    // 实时-时间-数据转换
    formatDate(value) {
      var year = value.getFullYear();
      var month = formatNum(value.getMonth() + 1);
      var day = formatNum(value.getDate());
      var hour = formatNum(value.getHours());
      var min = formatNum(value.getMinutes());
      var sec = formatNum(value.getSeconds());
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
  },
  props: ["generatingCapacityList"],
  watch: {
    generatingCapacityList: function (newVal, oldVal) {
      console.log("generatingCapacityList");
      this.listData();
    },
  },
  mounted() {
    console.log(this.formatDate(new Date()) + "时间----------");

    this.listData();
  },
  methods: {
    formatDate(value) {
      var year = value.getFullYear();
      var month = formatNum(value.getMonth() + 1);
      var day = formatNum(value.getDate());
      var hour = formatNum(value.getHours());
      var min = formatNum(value.getMinutes());
      var sec = formatNum(value.getSeconds());
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    close() {
      this.toolTipBox = false;
    },
    handleClick(val) {
      this.$emit("headerChange", val);
    },
    changeActive() {
      this.toolTipBox = true;
    },
    initData(val) {
      this.stationInformation.push({
        ...val,
        dataTime: this.formatDate(new Date()),
      });
      this.badge = this.stationInformation.length;
    },
    listData() {
      axios
        .get("/api/powermis/bigScreen/getDateGeneratingCapacity")
        .then((response) => {
          this.dataList = response.data.data;
          if (this.dataList.yearCompletionRate > 100) {
            this.yearCompletionRate = 100;
          } else {
            this.yearCompletionRate = this.dataList.yearCompletionRate;
          }
        });
      axios
        .get("/api/powermis/bigScreen/getPowerStationSum")
        .then((response) => {
          this.busPowerStationCount = response.data.data.busPowerStationCount;
        });
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  background: url(../assets/header.png) no-repeat;
  background-size: 100% 100%;
  height: 150px;
}
.context {
  display: flex;
  align-items: center;
}
.header_tisk img {
  width: 70px;
  height: 70px;
}
.header_right img {
  width: 100px;
  height: 100px;
}
.header_title {
  color: white;
  display: flex;
  padding-top: 38px;
  font-size: 15px;
  align-items: center;
  margin-right: 1%;
}
.progressBarTop {
  width: 65px;
  border-radius: 23px;
  height: 10px;
  background-color: #4994e3;
}
.progressBar {
  width: 77.64%;
  background-image: linear-gradient(to right, #9a1f0d, #f77878);
  height: 10px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.header_right span {
  font-size: 17px;
  text-decoration: underline;
}
.progressBarButtom {
  width: 23px;
  border-radius: 23px;
  height: 10px;
  background: linear-gradient(90deg, #005878 0%, #97d9ff 100%);
}
.header_left {
  margin-left: 1%;
  border-right: 2px solid #27587a;
  padding-right: 0.5%;
  height: 32px;
  padding-top: 5px;
  font-size: 17px;
  margin-top: -24px;
  padding-bottom: 8px;
}
.header_title span {
  text-decoration: underline;
  font-size: 17px;
  margin-left: 3px;
  font-weight: 900;
}
.header_right_title {
  display: flex;
  margin-left: auto;
  align-items: center;
  text-align: center;
  margin-top: -23px;
}
.header_right_title .header_right {
  margin-right: 0px;
  font-size: 15px;
  padding-left: 0px;
  padding-right: 10px;
  width: 100px;
}
.header_right_title .header_right:nth-child(1) {
  border-right: 2px solid #27587a;
  margin-right: 2%;
}
.header_right_title .header_right:nth-child(2) {
}
.header_right_title .header_right:last-child {
  margin-left: -39px;
}
.number {
  font-size: 17px;
  width: 100px;
}
.header_left span {
  font-size: 23px;
}
.edit {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 19px;
  margin: 5px;
  cursor: pointer;
}
.toolTipBox {
  width: 10%;
  padding: 1%;
  overflow: auto;
  background-color: white;
  width: 20%;
  background-color: white;
  position: absolute;
  font-size: 16px;
  border-radius: 10px;
  max-height: 700px;
  color: #000;
  right: 1%;
  top: 83px;
  z-index: 999;
}
.close {
  color: #888888;
  font-weight: 900;
  cursor: pointer;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue